/**
 * Font configuration for the drawing system.
 *
 * Fonts are loaded from public/fonts/{fontname}/{fontname}.ttf
 * and registered with ODA via app.registerFontFileName().
 */

export type FontInfo = {
  name: string; // Typeface of font name
  filename: string; // name of the file as it is on FS
  url: string; // Path to fetch file
};

// Default font used throughout the application
export const DEFAULT_FONT: FontInfo = {
  name: "Arial", // font name or typeface
  filename: "arial.ttf",
  url: "/fonts/arial/arial.ttf",
};

// List of available fonts for user selection
// These must match the actual font files in public/fonts/
// name is like font or typeface
export const AVAILABLE_FONTS: FontInfo[] = [
  { name: "Arial", filename: "arial.ttf", url: "/fonts/arial/arial.ttf" },
  {
    name: "Times New Roman",
    filename: "times.ttf",
    url: "/fonts/times/times.ttf",
  },
  {
    name: "Verdana",
    filename: "verdana.ttf",
    url: "/fonts/verdana/verdana.ttf",
  },
  {
    name: "Calibri",
    filename: "calibri.ttf",
    url: "/fonts/calibri/calibri.ttf",
  },
  // keep simplex.shx to match autoCAD naming
  {
    name: "simplex.shx",
    filename: "simplex.ttf",
    url: "/fonts/simplex/simplex.ttf",
  },
];

/** Retrieves the font info matching the given filename from the available fonts list. */
export function getFontForFileName(filename: string): FontInfo | undefined {
  return AVAILABLE_FONTS.find((font) => font.filename === filename);
}
